<iframe name="ng-frame" [src]="src | safe" [width]="width" [height]="height" frameborder="0" allowfullscreen
  *ngIf="!methodLogin;else noAccess"> </iframe>
<ng-template #noAccess>
  <div class="container">
    <div class="alert alert-primary" i18n>This page is still not available.</div>
  </div>
</ng-template>
